import React, { Component } from 'react';
import { apiCall } from '../utils/api';
import './VideoList.css';
import { FaMapMarkerAlt } from "react-icons/fa";

class VideoList extends Component {
  state = {
    pages: [],
    selectedPage: null,
    showModal: false,
    selectedVideo: null,
    currentImageIndexes: {}
  }

  componentDidMount() {
    if (this.props.user) {
      this.fetchPages();
    }
  }

  componentDidUpdate(prevProps) {
    // Si l'utilisateur change, on recharge les pages
    if (prevProps.user !== this.props.user) {
      this.fetchPages();
    }
  }

  componentWillUnmount() {
    // Nettoyer tous les intervalles
    Object.keys(this.state.currentImageIndexes).forEach(videoId => {
      clearInterval(this.intervals[videoId]);
    });
  }

  intervals = {};

  fetchPages = async () => {
    try {
      // On s'assure d'avoir un utilisateur connecté
      if (!this.props.user?.id) {
        this.setState({ pages: [] });
        return;
      }

      const pages = await apiCall('pages', { user_id: this.props.user.id });
      this.setState({ pages });
      if (pages.length > 0) {
        this.setState({ selectedPage: pages[0] });
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des pages:', error);
    }
  }

  handlePageSelect = (page) => {
    this.setState({ selectedPage: page });
  }

  handleVideoClick = (video) => {
    this.setState({ 
      selectedVideo: video,
      showModal: true
    });
  }

  closeModal = () => {
    this.setState({ showModal: false });
  }

  startImageRotation = (videoId) => {
    // Arrêter l'intervalle existant s'il y en a un
    if (this.intervals[videoId]) {
      clearInterval(this.intervals[videoId]);
    }

    // Démarrer un nouvel intervalle
    this.intervals[videoId] = setInterval(() => {
      this.setState(prevState => ({
        currentImageIndexes: {
          ...prevState.currentImageIndexes,
          [videoId]: ((prevState.currentImageIndexes[videoId] || 0) + 1) % 4
        }
      }));
    }, 1500);
  }

  render() {
    const { pages, selectedPage, showModal, selectedVideo, currentImageIndexes } = this.state;

    // Si pas d'utilisateur connecté, on affiche un message
    if (!this.props.user) {
      return (
        <div className="not-connected">
          <h2>Veuillez vous connecter pour voir les vidéos</h2>
        </div>
      );
    }

    // Si pas de pages disponibles
    if (this.state.pages.length === 0) {
      return (
        <div className="no-pages">
          <h2>Aucune vidéo disponible</h2>
        </div>
      );
    }

    return (
      <div className="d-flex" style={{ minHeight: '90vh' }}>
        {/* Menu latéral */}
        <aside className="bg-dark text-light" style={{ minHeight: '100%' }}>
          <ul className="nav flex-column">
            {pages.map(page => (
              <li key={page.id} className="nav-item mb-2">
                <button
                  className={`nav-link text-light d-flex align-items-center ${selectedPage && selectedPage.id === page.id ? 'active bg-secondary' : ''}`}
                  style={{ border: 'none', background: 'none', width: '100%', textAlign: 'left' }}
                  onClick={() => this.handlePageSelect(page)}
                >
                  <FaMapMarkerAlt className="me-2" />
                  {page.titre}
                </button>
              </li>
            ))}
          </ul>
        </aside>

        {/* Contenu principal */}
        <div className="p-4 container-fluid">
          {selectedPage && (
            <>
              <h2>{selectedPage.titre}</h2>
              <div className="mb-3 text-muted">{selectedPage.description}</div>
              <div className="row">
                {selectedPage.videos.map((video, idx) => {
                  const images = [
                    `https://i.ytimg.com/vi/${video.youtube_id}/hqdefault.jpg`,
                    `https://i.ytimg.com/vi/${video.youtube_id}/hq1.jpg`,
                    `https://i.ytimg.com/vi/${video.youtube_id}/hq2.jpg`,
                    `https://i.ytimg.com/vi/${video.youtube_id}/hq3.jpg`
                  ];
                  const currentIndex = currentImageIndexes[video.id] || 0;

                  if (!this.intervals[video.id]) {
                    this.startImageRotation(video.id);
                  }

                  return (
                    <div className="col-md-6 d-flex flex-column align-items-center mb-4" key={video.id}>
                      <h4 className="text-light text-center">{video.name}</h4>
                      <div className="video-thumbnail position-relative" style={{ width: '100%', maxWidth: 395 }}>
                        <img 
                          src={images[currentIndex]} 
                          alt={video.name}
                          onClick={() => this.handleVideoClick(video)}
                          className="img-fluid rounded"
                          style={{ cursor: 'pointer', width: '100%' }}
                        />
                        <div 
                          className="play-button"
                          style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            fontSize: 56,
                            color: 'white',
                            opacity: 0.85,
                            pointerEvents: 'none',
                            textShadow: '0 0 10px #000'
                          }}
                        >▶</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>

        {showModal && selectedVideo && (
          <div 
            className="modal fade show"
            style={{
              display: 'block',
              background: 'rgba(0,0,0,0.8)',
              position: 'fixed',
              top: 0, left: 0, right: 0, bottom: 0,
              zIndex: 1050
            }}
            tabIndex="-1"
            onClick={this.closeModal}
          >
            <div 
              style={{ 
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '60%',
                maxWidth: '1200px'
              }}
              onClick={e => e.stopPropagation()}
            >
              <div style={{ position: 'relative', paddingTop: '56.25%' }}>
                <iframe
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    border: 'none'
                  }}
                  src={`https://www.youtube.com/embed/${selectedVideo.youtube_id}?autoplay=1`}
                  title={selectedVideo.name}
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default VideoList; 